(function () {
    'use strict';

    angular.module('app')
        .directive('pagination', function() {
            return {
                templateUrl: 'components/directives/pagination/view.pagination.html',
                controller: 'PaginationController',
                controllerAs: 'vm',
                scope: {
                    'page': '=',
                    'total': '=',
                    'size': '=',
                    'update': '='
                },
                bindToController: true
            }
        });
})();
